import { NavLink, Outlet } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { SquaresFour, Users, ListChecks, SignOut, BellRinging, Gear } from "@phosphor-icons/react";

const nav = [
  { to: "/", label: "Dashboard", icon: SquaresFour, testid: "nav-dashboard" },
  { to: "/customers", label: "Customers", icon: Users, testid: "nav-customers" },
  { to: "/tasks", label: "Tasks & Jobs", icon: ListChecks, testid: "nav-tasks" },
  { to: "/reminders", label: "Reminders", icon: BellRinging, testid: "nav-reminders" },
];

export default function Layout() {
  const { user, logout } = useAuth();
  const isAdmin = user?.role === "owner" || user?.role === "admin";
  const items = isAdmin ? [...nav, { to: "/settings", label: "Settings", icon: Gear, testid: "nav-settings" }] : nav;

  return (
    <div className="min-h-screen flex">
      <aside className="w-64 shrink-0 bg-[#16205A] text-white flex flex-col fixed h-screen">
        <div className="p-5 border-b border-white/10 flex items-center gap-3">
          <div className="bg-white rounded-xl p-1.5 shadow-lg">
            <img src="/logo.png" alt="Betonwapening Veeris 2.0" className="w-10 h-10 object-contain" />
          </div>
          <div>
            <h1 className="font-heading font-extrabold text-base leading-none">BETONWAPENING</h1>
            <p className="font-mono text-[10px] text-[#F49B1C] tracking-widest mt-0.5">VEERIS 2.0</p>
          </div>
        </div>

        <nav className="flex-1 p-3 space-y-1 mt-2">
          {items.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.to === "/"}
              data-testid={n.testid}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3.5 py-2.5 rounded-lg font-semibold text-sm transition-all ${
                  isActive
                    ? "bg-[#F49B1C] text-white shadow-md shadow-black/20"
                    : "text-slate-300 hover:bg-white/10 hover:text-white"
                }`
              }
            >
              <n.icon size={20} weight={undefined} />
              {n.label}
            </NavLink>
          ))}
        </nav>

        <div className="p-3 border-t border-white/10">
          <div className="px-2 mb-2">
            <p className="text-xs font-semibold text-white truncate">{user?.name || "Owner"}</p>
            <p className="font-mono text-[10px] text-slate-400 truncate">{user?.email}</p>
          </div>
          <button
            data-testid="logout-button"
            onClick={logout}
            className="w-full flex items-center gap-2 justify-center px-3 py-2.5 rounded-lg bg-white/5 hover:bg-white/15 text-sm font-semibold transition-colors"
          >
            <SignOut size={18} weight="bold" /> Log out
          </button>
        </div>
      </aside>

      <main className="flex-1 ml-64 min-h-screen">
        <Outlet />
      </main>
    </div>
  );
}
